import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { AllProgressCheckPdfScreenPath } from "./paths.ts";

export function useToAllProgressCheckPdfs() {
  const navigate = useNavigate();

  const toAllProgressCheckPdfs = useCallback(() => {
    navigate(AllProgressCheckPdfScreenPath);
  }, [navigate]);

  return { toAllProgressCheckPdfs };
}
